document.addEventListener("turbolinks:load", function() {

  $(".open-collapse-panel").click(function(){
    $(this).parents('.panel-heading').find(".open-collapse-panel .item-chevron-icon").toggleClass('d-none');
  });

});
